import DecimalService from '../decimalService';

const divideNumbersAsDecimals = (a: number, b: number) => {
    const decimalA = DecimalService.parse(a);
    const decimalB = DecimalService.parse(b);
    const product = DecimalService.divide(decimalA, decimalB);

    return DecimalService.toNumber(product);
};

export default divideNumbersAsDecimals;
